import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { getLang } from '../api';
import en from './en';
import vi from './vi';
import fr from './fr';
import de from './de';
import ru from './ru';
import ja from './ja';
import ko from './ko';
import cn from './cn';
import tw from './tw';
import th from './th';

// the translations
// (tip move them in a JSON file and import them)
const resources = {
    en: {
        translation: en
    },
    vi: {
        translation: vi
    },
    fr: {
        translation: fr
    },
    de: {
        translation: de
    },
    ru: {
        translation: ru
    },
    ja: {
        translation: ja
    },
    ko: {
        translation: ko
    },
    cn: {
        translation: cn
    },
    tw: {
        translation: tw
    },
    th: {
        translation: th
    }
};

i18n.use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: getLang(),
        fallbackLng: "en", // use en if detected lng is not available
        // keySeparator: false, // we do not use keys in form messages.welcome
        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;